import { Component } from '@angular/core';
import { WHATSAPP_URL } from '../nav-items';

/** Faixa superior do header com os telefones (oculta no mobile). */
@Component({
  selector: 'app-header-contacts',
  templateUrl: './header-contacts.html',
  styleUrl: './header-contacts.scss',
})
export class HeaderContacts {
  protected readonly whatsappUrl = WHATSAPP_URL;
}
